import { render, staticRenderFns } from "./DropFileV3.vue?vue&type=template&id=75466653&scoped=true"
import script from "./DropFileV3.vue?vue&type=script&lang=js"
export * from "./DropFileV3.vue?vue&type=script&lang=js"
import style0 from "./DropFileV3.vue?vue&type=style&index=0&id=75466653&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75466653",
  null
  
)

export default component.exports